module.exports = __webpack_public_path__ + "img/journey-email-scratch-non-graphical.3f1e96b9.png";